import "./index.css";
import Switch from "../../../../../Components/Switch";

const SettingsPopup = ({
  settings,
  setSettings,
  recoverFromFrozenState,
  closePopup,
}) => {
  return (
    <div className="speakingPopupWrapper">
      <div className="speakingPopupBackdrop" />
      <div className="speakingPopupContainer">
        <div className="speakingPopupHeaderContainer">
          <h2>Speaking Section Settings</h2>
          <button
            className="speakingPopupCloseButton popupCloseButton"
            onClick={closePopup}
          />
        </div>
        <div className="speakingSettingsPopupContentWrapper">
          <div className="speakingSettingsToggleWrapper">
            <h3>Disable Auto Send</h3>
            <p>
              Manually send audio recordings instead of detecting pause time.
            </p>
            <Switch
              customClass={"speakingSettingsToggleSwitch"}
              value={settings.disableAutoSend}
              onClick={() =>
                setSettings({
                  ...settings,
                  disableAutoSend: !settings.disableAutoSend,
                })
              }
            />
          </div>
          <div className="speakingSettingsToggleWrapper">
            <h3>Manual Audio Start</h3>
            <p>
              Require pressing a button to start a recording instead of
              detecting speaking.
            </p>
            <Switch
              customClass={"speakingSettingsToggleSwitch"}
              value={settings.manualAudioStart}
              onClick={() =>
                setSettings({
                  ...settings,
                  manualAudioStart: !settings.manualAudioStart,
                })
              }
            />
          </div>
          <div className="speakingSettingsToggleWrapper">
            <h3>Hide Transcriptions</h3>
            <p>Hide text transcriptions in the chat history.</p>
            <Switch
              customClass={"speakingSettingsToggleSwitch"}
              value={settings.hideTranscriptions}
              onClick={() =>
                setSettings({
                  ...settings,
                  hideTranscriptions: !settings.hideTranscriptions,
                })
              }
            />
          </div>
          <div className="speakingSettingsToggleWrapper">
            <h3>Recover From Frozen</h3>
            <p>
              This is a development feature to unfreeze the application if it
              freezes.
            </p>
            <button
              className="speakingSettingsButton"
              onClick={recoverFromFrozenState}
            >
              Recover
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPopup;
